import { render, staticRenderFns } from "./FirstRowTransportSettlementLumpSumSet.vue?vue&type=template&id=2312b846&scoped=true&"
import script from "./FirstRowTransportSettlementLumpSumSet.vue?vue&type=script&lang=js&"
export * from "./FirstRowTransportSettlementLumpSumSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312b846",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2312b846')) {
      api.createRecord('2312b846', component.options)
    } else {
      api.reload('2312b846', component.options)
    }
    module.hot.accept("./FirstRowTransportSettlementLumpSumSet.vue?vue&type=template&id=2312b846&scoped=true&", function () {
      api.rerender('2312b846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Delegation/DelegationFormStandard/transport/FirstRowTransportSettlementLumpSumSet.vue"
export default component.exports